import { FC } from 'react';
import { Card, Table, Empty, Typography, Skeleton } from 'antd';
import { useGet } from '../../../../../hooks/useApi';
import { StudentLogEntry } from '../../../../../models/admin/student-admin.model';

const { Text } = Typography;

interface LogsTabProps {
  studentId: number;
}

const LogsTab: FC<LogsTabProps> = ({ studentId }) => {
  const { data, isLoading, isError } = useGet<StudentLogEntry[]>(
    `/v1/auth/admin/students/${studentId}/logs`,
    { enabled: !!studentId }
  );

  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const columns = [
    {
      title: 'Date/Time',
      dataIndex: 'changedAt',
      key: 'changedAt',
      render: (date: string) => formatDate(date),
      width: 180,
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: 120,
    },
    {
      title: 'Field',
      dataIndex: 'field',
      key: 'field',
      render: (field: string | null) => field || '-',
      width: 150,
    },
    {
      title: 'Old Value',
      dataIndex: 'oldValue',
      key: 'oldValue',
      render: (value: string | null) => (
        <Text type="secondary">{value || '-'}</Text>
      ),
    },
    {
      title: 'New Value',
      dataIndex: 'newValue',
      key: 'newValue',
      render: (value: string | null) => value || '-',
    },
    {
      title: 'Changed By',
      dataIndex: 'changedBy',
      key: 'changedBy',
      width: 150,
    },
  ];

  if (isLoading) {
    return (
      <Card title="Change History">
        <Skeleton active paragraph={{ rows: 5 }} />
      </Card>
    );
  }

  if (isError) {
    return (
      <Card title="Change History">
        <Empty description="Error loading change history" />
      </Card>
    );
  }

  return (
    <Card title="Change History">
      {data && data.length > 0 ? (
        <Table
          dataSource={data}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 20 }}
          size="small"
          scroll={{ x: true }}
        />
      ) : (
        <Empty description="No change history available" />
      )}
    </Card>
  );
};

export default LogsTab;
